<template>
  <div id="home">
    <div class="inner-wrapper">
      <main class="inner-content">
        <header>
          <h1 class="intro-copy">
            Multiple Sclerosis (MS) Disease Progression Visualizer
          </h1>
          <h2 class="app-title">Explore MS Disease Progression Over Time</h2>
        </header>

        <p>
          <router-link
            @click.native="
              $gtag.event('click', {
                event_category: 'launch_tutorial',
                event_label: 'tutorial',
              })
            "
            to="tutorial"
            class="btn-begin"
            >Tutorial
            <span class="icon-chevron">
              <img src="@/assets/img/icon-chevron.svg" alt="" /> </span
          ></router-link>
        </p>

        <p>
          <a href="#" @click="begin" class="btn-begin"
            >Begin
            <span class="icon-chevron">
              <img src="@/assets/img/icon-chevron.svg" alt="" /> </span
          ></a>
        </p>

        <p class="disclaimer">
          Disclaimer: Timelines over 20 years for disability (as evaluated by
          the Expanded Disability Status Scale; EDSS), adaptive autoimmune
          response, chronic inflammation, demyelination, and axonal
          transection/degeneration are taken from Kotelnikova et al. 2017 and
          based on a mathematical model fitted to clinical data. The model was
          validated with clinical data from a second prospective cohort for
          which EDSS data and other time series measures were available.<sup
            >1</sup
          >
        </p>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.$store.toggleAudio(false);
    this.$pauseSound();
  },
  methods: {
    begin(e) {
      e.preventDefault();
      this.$store.updateYear(0);
      this.$router.push("/disease-progression");
      this.$gtag.event("click", {
        event_category: "start_app",
        event_label: "start",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#home {
  width: 100%;
  position: relative;
  background: url("../assets/img/bg_home.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &:before {
    content: "";
    width: 100%;
    height: 55%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba($blue-dark-bg, 1) 0%,
      rgba($blue-dark-bg, 0) 100%
    );
  }

  &:after {
    content: "";
    width: 100%;
    height: 30%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba($blue-dark-bg, 0) 0%,
      rgba($blue-dark-bg, 1) 100%
    );
  }

  // Issue #94: iPad specific media query
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
    height: calc(100vh - 104px - 32px);
  }
}

.app-title {
  font-size: rem(50px);
  margin-top: rem(20px);
  margin-bottom: rem(40px);
  width: 60%;
  @include breakpoint(xs) {
    font-size: rem(36px);
  }
}

.intro-copy {
  margin-bottom: rem(25px);
  width: 80%;
  font-size: rem(20px);
  text-transform: uppercase;
  font-weight: $font-weight-bold;

  @media screen and (orientation: portrait) {
    width: 100%;
    font-size: rem(20px);
  }
}

.inner-wrapper {
  padding-bottom: rem(100px);
  position: relative;
  z-index: 1;
  height: calc(100vh - 110px);
}

.inner-content {
  height: 100%;
}

.btn-begin {
  width: 200px;
  border: 2px solid $white;
  color: $white;
  background: none;
  padding: rem(14px) rem(20px);
  display: inline-block;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon-chevron {
    width: 11px;
    height: 20px;

    img {
      width: 100%;
    }
  }
  &:focus {
    outline: 4px solid#FFD086;
  }
}

// placeholder element for assets
.placeholder {
  background: $grey;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    color: black;
    font-size: rem(60px);
  }
}

.disclaimer {
  margin: 0;
  font-size: rem(12px);
  font-style: italic;
  position: absolute;
  max-width: 768px;
  bottom: 10px;

  // Issue #94: iPad specific media query
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
    bottom: 40px;
  }
}
</style>
